import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

export const findOrdersCountAndNetInvoiceSumByAdm = async ({ admNumber, year }) => {
  const getFilters = (year) => {
    return [
      { field: "year", operator: "eq", value: year },
      { field: "orderType", operator: "in", value: "AU;NL;DL;BA" },
      { field: "orderStatus", operator: "eq", value: "G" },
    ]
  }
  const currentYear = new Date().getFullYear().toString()
  const filters = year ? getFilters(year) : getFilters(currentYear)
  const variables = { admNumber, filters: filters }

  const fields = ["admNumber", "orderCount", "orderNetInvoiceSum"]

  const graphiQLQueryObject = [
    {
      method: "openOrders: findOrdersCountAndNetInvoiceSumByAdmAndFilter",
      variables: variables,
      fields,
    },
  ]
  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)

  const queryResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data

  if (!queryResponse) throw new Error("Data retrieval for open order count failed")

  return { openOrders: queryResponse?.openOrders }
}
